import { type ReactNode } from 'react';

interface HeaderSummaryProps {
    name: string;
    value: string;
}

export function HeaderSummary({ name, value }: HeaderSummaryProps): ReactNode {
    return (
        <div className="flex justify-content-between">
            <div className="flex flex-column gap-1">
                <h4>{name}</h4>
                <span>{value}</span>
            </div>
        </div>
    );
}
